type JwtResolver = () => string
let _resolveJwt: JwtResolver = () => ''
let _resolveVulcanJwt: JwtResolver

export const SetJwtResolver = (resolver: JwtResolver) => { _resolveJwt = resolver };
export const SetVulcanJwtResolver = (resolver: JwtResolver) => { _resolveVulcanJwt = resolver };
export const GetJwt = (upstream: 'snex' | 'vulcan' = 'snex') => {
    if(upstream === 'vulcan' && _resolveVulcanJwt) return _resolveVulcanJwt()
    return _resolveJwt()
}